(function () {
  'use strict';

  var root = document.querySelector('[data-czard-nav]');
  if (!root) return;

  var toggle = root.querySelector('[data-czard-nav-toggle]');
  var panel = root.querySelector('[data-czard-nav-panel]');
  if (!toggle || !panel) return;

  var open = false;

  function setOpen(next) {
    if (next === open) return;
    open = next;

    root.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

    // inert keeps a closed panel out of the tab order entirely — a
    // visibility:hidden panel is skipped by some browsers and not others
    if (open) panel.removeAttribute('inert');
    else panel.setAttribute('inert', '');
  }

  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    setOpen(!open);
  });

  // a click anywhere else closes it; the panel itself is exempt so following
  // a link is not intercepted by its own container
  document.addEventListener('click', function (e) {
    if (!open) return;
    if (root.contains(e.target)) return;
    setOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !open) return;
    setOpen(false);
    toggle.focus();
  });

  // The immersive home page reads pointer events at the window to swing its
  // camera and to drive the cursor ring. Only the press is stopped here, and
  // deliberately not pointermove: that is what carries the ring and the smoke
  // trail, and swallowing it strands both over this corner.
  ['pointerdown', 'pointerup'].forEach(function (evt) {
    root.addEventListener(evt, function (e) { e.stopPropagation(); });
  });
})();
